module Meevo.Plugins.Equipment {
    "use strict";

    /**
    * Main Section of Client 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Equipment> {

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        private _activeState: boolean;

        get activeState(): boolean {
            if (this.model !== undefined) {
                if (this.model.objectState === Model.ObjectStateEnum.Active) {
                    return true;
                }
            }

            return false;
        }
        createSectionModelCopy(): Model.Equipment {
            let item = <Model.Equipment>(this.model);
            item.id = null;
            return item;
        }

        set activeState(value: boolean) {
            if (this.model !== undefined) {
                if (value) {
                    this.model.objectState = Model.ObjectStateEnum.Active;
                } else {
                    if (this.model.objectState !== Model.ObjectStateEnum.Deleted) {
                        this.model.objectState = Model.ObjectStateEnum.Inactive;
                    }
                }
            }
        }

        postCopy(): void {
        }

        statusChanged(context: any): void {
            if (this.model.objectState == Model.ObjectStateEnum.Active) {
                this.showHasServicesPrompt(context);
            }
        }

        quantityChanged(context: any): void {
            if (this.model.quantity == 0) {
                this.showHasServicesPrompt(context);
            }
        }

        showHasServicesPrompt(context: any): any {
            if (this.model.usedByServices) {
                const messageConfig = { serviceDisplayName: this.model.displayName };

               return context.modalService.alert(context.modalService.translate.instant("MESSAGE_SERVICES_ASSOCIATED_EQUIPMENT", messageConfig));
            }
        }
    }

}